import useToken from "../Components/useToken";
import React, { useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import SearchForm from "../Components/SearchForm";
import axios from "axios";
import { Navbar, Nav, Container, Offcanvas } from "react-bootstrap";
import {
  APIProvider,
  ControlPosition,
  MapControl,
  AdvancedMarker,
  Map,
  useMap,
  useMapsLibrary,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";

const PlaceAutocomplete = ({ onPlaceSelect, defaultValue = "" }) => {
  const [placeAutocomplete, setPlaceAutocomplete] = useState(null);
  const inputRef = useRef(null);
  const places = useMapsLibrary("places");

  useEffect(() => {
    if (!places || !inputRef.current) return;

    const options = {
      fields: ["geometry", "name", "formatted_address"],
    };

    setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
  }, [places]);

  useEffect(() => {
    if (!placeAutocomplete) return;

    const listener = placeAutocomplete.addListener("place_changed", () => {
      const place = placeAutocomplete.getPlace();
      if (inputRef.current) {
        inputRef.current.value = place.formatted_address || place.name || "";
      }
      onPlaceSelect(place.formatted_address || place.name || "");
    });

    // Cleanup function to remove the listener when component unmounts or dependencies change
    return () => {
      if (listener && window.google && window.google.maps && window.google.maps.event) {
        window.google.maps.event.removeListener(listener);
      }
    };
  }, [onPlaceSelect, placeAutocomplete]);

  useEffect(() => {
    if (inputRef.current && defaultValue) {
      inputRef.current.value = defaultValue;
    }
  }, [defaultValue]);

  return (
    <div className="autocomplete-container">
      <input
        ref={inputRef}
        placeholder="Cerca indirizzo..."
      />
    </div>
  );
};

async function getAlloggi(token) {
  let result = await fetch(`${process.env.REACT_APP_API_KEY}/admin/alloggi`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).then((data) => data.json());

  // return result from last to first
  return result.reverse();
}

async function getTappeConferma(token) {
  let result = await fetch(
    `${process.env.REACT_APP_API_KEY}/admin/alloggi?stato=0`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  ).then((data) => data.json());
  return result;
}

async function getTappe(token) {
  let result = await fetch(`${process.env.REACT_APP_API_KEY}/admin/tappe?attivo=0`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).then((data) => data.json());
  return result;
}

async function deleteAlloggio(token, id_alloggio, foto, nome) {
  const formData = new FormData();
  formData.append(
    "body",
    JSON.stringify({
      nome: nome,
      attivo: 1,
      foto_alloggio: foto,
    })
  );

  let result = await axios.put(
    `${process.env.REACT_APP_API_KEY}/admin/alloggi/${id_alloggio}`,
    formData,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

async function checkCampi(
  nome,
  descrizione,
  file,
  link,
  luogo,
  tappa,
  upload_preview,
  foto
) {
  if (
    file &&
    file.type != "image/png" &&
    file &&
    file.type != "image/jpeg" &&
    file &&
    file.type != "image/webp"
  ) {
    return "Formato Immagine non supportato.";
  }
  if (file && file.size > 1000000) {
    return "Immagine troppo pesante. Inserire immagine più leggera.";
  }

  // Solo 3 campi obbligatori: Nome, Indirizzo (luogo), Tappa
  if (!nome || nome == "") {
    return "Errore. Inserire nome";
  } else if (!luogo || luogo == "") {
    return "Errore. Inserire indirizzo";
  } else if (!tappa || tappa == "") {
    return "Errore. Selezionare una tappa";
  } else return true;
}

async function insertAlloggio(
  token,
  id_alloggio,
  nome,
  descrizione,
  file,
  prezzo_min,
  prezzo_max,
  link,
  luogo,
  numero_telefono,
  email,
  costo_pre_prenotazione,
  id_tappa,
  attivo,
  nome_en,
  descrizione_en,
  luogo_en
) {
  const formData = new FormData();
  formData.append("profileImg", file);
  formData.append(
    "body",
    JSON.stringify({
      nome: nome,
      descrizione: descrizione,
      prezzo_min: prezzo_min,
      prezzo_max: prezzo_max,
      link: link,
      luogo: luogo,
      numero_telefono: numero_telefono,
      email: email,
      costo_pre_prenotazione: costo_pre_prenotazione,
      id_tappa: id_tappa,
      attivo: attivo,
      stato: 1,
      nome_en: nome_en,
      descrizione_en: descrizione_en,
      luogo_en: luogo_en
    })
  );
  // NB: non impostare Content-Type manualmente. FormData richiede
  // multipart/form-data con il boundary che axios/browser generano in
  // automatico — forzare application/json rompe il parsing lato server.
  let result = await axios.post(
    `${process.env.REACT_APP_API_KEY}/admin/alloggi`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      timeout: 30000,
    }
  );
  return result.data;
}

async function updateAlloggio(
  token,
  id_alloggio,
  nome,
  file2,
  descrizione,
  prezzo_min,
  prezzo_max,
  link,
  luogo,
  numero_telefono,
  email,
  costo_pre_prenotazione,
  id_tappa,
  foto,
  attivo,
  nome_en,
  descrizione_en,
  luogo_en,
  ztl
) {
  const formData = new FormData();
  if (file2) {
    formData.append("profileImg", file2);
    formData.append(
      "body",
      JSON.stringify({
        nome: nome,
        descrizione: descrizione,
        prezzo_min: prezzo_min,
        prezzo_max: prezzo_max,
        link: link,
        luogo: luogo,
        numero_telefono: numero_telefono,
        email: email,
        costo_pre_prenotazione: costo_pre_prenotazione,
        id_tappa: id_tappa,
        attivo: attivo,
        nome_en: nome_en,
        descrizione_en: descrizione_en,
        luogo_en: luogo_en,
        ztl: ztl
      })
    );
  } else {
    formData.append(
      "body",
      JSON.stringify({
        nome: nome,
        descrizione: descrizione,
        prezzo_min: prezzo_min,
        prezzo_max: prezzo_max,
        link: link,
        luogo: luogo,
        numero_telefono: numero_telefono,
        email: email,
        costo_pre_prenotazione: costo_pre_prenotazione,
        id_tappa: id_tappa,
        foto_alloggio: foto,
        attivo: attivo,
        nome_en: nome_en,
        descrizione_en: descrizione_en,
        luogo_en: luogo_en,
        ztl: ztl
      })
    );
  }

  // Stesso motivo di insertAlloggio: niente Content-Type manuale su FormData.
  let result = await axios.put(
    `${process.env.REACT_APP_API_KEY}/admin/alloggi/${id_alloggio}`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      timeout: 30000,
    }
  );

  return result.data;
}

async function updateAlloggio1(token, id_alloggio, nome, attivo, foto) {
  const formData = new FormData();

  formData.append(
    "body",
    JSON.stringify({
      nome: nome,
      foto_alloggio: foto,
      attivo: attivo,
      stato: 1,
    })
  );

  // FormData → niente Content-Type manuale.
  let result = await axios.put(
    `${process.env.REACT_APP_API_KEY}/admin/alloggi/${id_alloggio}`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      timeout: 30000,
    }
  );

  return result.data;
}

const Alloggi = () => {
  const [conferma, setConferma] = useState(false);
  const search = (keyword) => {
    let alloggi = alloggiBackup.filter((el) =>
      el.nome.toUpperCase().includes(keyword.toUpperCase())
    );
    if (alloggi?.length == 0) {
      alloggi = alloggiBackup.filter((el) =>
        el.luogo.toUpperCase().includes(keyword.toUpperCase())
      );
    }

    setAlloggi(alloggi);
  };

  const [loader, setLoader] = useState(false);
  const { token, setToken } = useToken();
  const [alloggi, setAlloggi] = useState([]);
  const [alloggiBackup, setAlloggiBackup] = useState([]);
  const [show, setShow] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [upload_preview, setUploadPreview] = useState(
    "/immagine_profilo_default.svg"
  );
  const [attivo, setAttivo] = useState(0);
  const [open, setOpen] = useState(false);
  const [button_conferma, setButtonConferma] = useState(false);
  const [nome_referente, setNomeReferente] = useState();
  const [nome_en, setNomeEn] = useState("");
  const [descrizione_en, setDescrizioneEn] = useState("");
  const [luogo_en, setLuogoEn] = useState("");

  const [modalError, setModalError] = useState("");

  // Filtri per colonna
  const [filterId, setFilterId] = useState("");
  const [filtroAttivo, setFiltroAttivo] = useState("");
  const [filtroStruttura, setFiltroStruttura] = useState("");
  const [filtroLocalita, setFiltroLocalita] = useState("");
  const [filtroTappa, setFiltroTappa] = useState("");

  // Funzione per applicare tutti i filtri
  const applicaFiltri = () => {
    let risultato = [...alloggiBackup];

    if (filterId) {
      risultato = risultato.filter((a) =>
        a.id.toString().includes(filterId)
      );
    }

    if (filtroAttivo !== "") {
      risultato = risultato.filter((a) =>
        a.attivo.toString() === filtroAttivo
      );
    }

    if (filtroStruttura) {
      risultato = risultato.filter((a) =>
        a.nome.toUpperCase().includes(filtroStruttura.toUpperCase())
      );
    }

    if (filtroLocalita) {
      risultato = risultato.filter((a) =>
        a.luogo.toUpperCase().includes(filtroLocalita.toUpperCase())
      );
    }

    if (filtroTappa) {
      risultato = risultato.filter((a) =>
        (a.tappa_nome || "").toUpperCase().includes(filtroTappa.toUpperCase())
      );
    }

    setAlloggi(risultato);
  };

  // Effetto per applicare i filtri quando cambiano
  useEffect(() => {
    applicaFiltri();
  }, [filterId, filtroAttivo, filtroStruttura, filtroLocalita, filtroTappa, alloggiBackup]);

  const handleShowUpdate = () => setShowUpdate(true);
  const handleCloseUpdate = () => {
    setShowUpdate(false);
    setUploadPreview("/immagine_profilo_default.svg");
  };
  const handleShowInfo = () => setShowInfo(true);
  const handleCloseInfo = () => setShowInfo(false);
  const handleClose = () => {
    setShow(false);
    setModalError("");
    setTappe([]);
    setNome("");
    setDescrizione("");
    setFoto("");
    setPrezzoMin(0);
    setPrezzoMax(0);
    setLink("");
    setLuogo("");
    setNumeroTelefono(0);
    setEmail("");
    setTappa(0);
    setPrePrenotazione(0);
    setUploadPreview("/immagine_profilo_default.svg");
    setNomeEn("");
    setDescrizioneEn("");
    setLuogoEn("");
  };
  const handleShow = () => setShow(true);
  const [tappe, setTappe] = useState([]);
  const [nome, setNome] = useState("");
  const [id_alloggio, setIdAlloggio] = useState(0);
  const [descrizione, setDescrizione] = useState("");
  const [foto, setFoto] = useState("");
  const [file, setFile] = useState();
  const [prezzo_min, setPrezzoMin] = useState(0);
  const [prezzo_max, setPrezzoMax] = useState(0);
  const [link, setLink] = useState("");
  const [luogo, setLuogo] = useState("");
  const [numero_telefono, setNumeroTelefono] = useState("");
  const [email, setEmail] = useState("");
  const [tappa, setTappa] = useState(0);
  const [costo_pre_prenotazione, setPrePrenotazione] = useState(0);
  const [id_tappa, setId_tappa] = useState(0);
  const [ztl, setZtl] = useState("NO");

  const get_alloggi = useEffect(() => {
    const fetchData = async () => {
      let result = await getAlloggi(token);
      await setAlloggi(result);
      await setAlloggiBackup(result);

      for (let i = 0; i < result.length; i++) {
        if (result[i].stato == 0) {
          await setConferma(true);
          break;
        } else {
          await setConferma(false);
        }
      }

      setInterval(async () => {
        let result = await getAlloggi(token);
        await setAlloggi(result);
        await setAlloggiBackup(result);

        for (let i = 0; i < result.length; i++) {
          if (result[i].stato == 0) {
            await setConferma(true);
            break;
          } else {
            await setConferma(false);
          }
        }
      }, 500000);
    };
    fetchData();
  }, []);

  return (
    <div>
      <Modal
        show={modalError != ""}
        onHide={() => {
          setModalError("");
        }}
      >
        <Modal.Body>
          <div>
            <img
              onClick={() => {
                setModalError("");
              }}
              className="btn-close-img"
              src="/closeBtn.svg"
            />
          </div>
          <div
            style={{
              textAlign: "center",
              paddingTop: "50px",
              paddingBottom: "80px",
            }}
          >
            <img
              style={{ width: "60px" }}
              className="btn-close-img1"
              src="/errorImage.svg"
            />
            <div
              style={{
                color: "#FF1400",
                fontSize: "1.4em",
                fontWeight: "500",
                marginTop: "20px",
                marginBottom: "0px",
              }}
            >
              {modalError}
              <br></br>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showDelete} onHide={handleCloseInfo}>
        <Modal.Body>
          <div>
            <img
              onClick={() => {
                setShowDelete(false);
              }}
              className="btn-close-img"
              src="/closeBtn.svg"
            />
          </div>
          <div
            style={{
              textAlign: "center",
              paddingTop: "50px",
              paddingBottom: "80px",
            }}
          >
            <img
              style={{ width: "50px" }}
              className="btn-close-img1"
              src="/deletePopup.svg"
            />
            <p
              style={{
                color: "#FF1400",
                fontSize: "1.7em",
                fontWeight: "500",
                marginTop: "20px",
                marginBottom: "0px",
              }}
            >
              Disattiva Struttura
            </p>
            <p
              style={{
                color: "#2F2F2F",
                fontSize: "1.1em",
                fontWeight: "500",
                marginBottom: "5px",
              }}
            >
              Vuoi disattivare{" "}
              <span style={{ fontWeight: "700" }}>{nome}?</span>
            </p>
            <button
              onClick={async () => {
                await deleteAlloggio(token, id_alloggio, foto, nome);
                let result_post_delete = await getAlloggi(token);
                setShowDelete(false);
                setAlloggi(result_post_delete);
              }}
              className="buttonDelete"
              style={{
                marginTop: "15px",
                fontWeight: "600",
                height: "55px",
                backgroundColor: "transparent",
                border: "1px solid #FF1400",
                color: "#FF1400",
                fontSize: "1em",
                width: "40%",
                borderRadius: "20px",
              }}
            >
              Disattiva
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Offcanvas
        className="offcanvas-custom"
        placement="end"
        show={showUpdate}
        onHide={handleCloseUpdate}
      >
        <Offcanvas.Header>
          <img
            onClick={handleCloseUpdate}
            className="btn-close-img"
            src="/closeBtn.svg"
          />
          <p
            style={{
              color: "#B1B1B1",
              fontSize: "2em",
              marginBottom: "0",
              position: "absolute",
              left: "60px",
            }}
          >
            Strutture - Modifica
          </p>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div style={{ paddingLeft: "35px", paddingRight: "35px" }}>
            <h1
              style={{
                fontSize: "1.3em",
                fontWeight: "700",
                marginBottom: "0",
                marginTop: "30px",
              }}
            >
              Modifica
            </h1>
            <h2 style={{ fontSize: "1.6em", fontWeight: "300" }}>{nome}</h2>
            <div>
              <div>
                <div>
                  <div style={{ marginTop: "40px" }} className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      style={{ marginBottom: "20px" }}
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Cambia Immagine
                    </label>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        style={{
                          height: "100px",
                          width: "100px",
                          display: "inline-block",
                          backgroundImage: `url(${foto != "" &&
                            foto != null &&
                            upload_preview == "/immagine_profilo_default.svg"
                            ? foto
                            : upload_preview
                            })`,
                          backgroundSize: "cover",
                          borderRadius: "100%",
                          backgroundPosition: "center",
                        }}
                      ></div>
                      <label
                        htmlFor={`upload-photo-Immagine`}
                        className="file"
                        style={{
                          width: "70%",
                          position: "relative",
                          left: "20px",
                          bottom: "8px",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <span>
                          <h6
                            style={{
                              display: "inline-block",
                              marginBottom: "0px",
                            }}
                          >
                            Aggiungi Immagine
                          </h6>
                        </span>
                        <input
                          type="file"
                          style={{
                            opacity: "0",
                            position: "absolute",
                            zIndex: "-1",
                          }}
                          id={`upload-photo-Immagine`}
                          onChange={async (e) => {
                            if (e.target.files[0]) {
                              await setUploadPreview(
                                URL.createObjectURL(e.target.files[0])
                              );
                            }
                            await setFile(e.target.files[0]);
                          }}
                        />
                      </label>
                    </div>
                  </div>
                  {button_conferma && (
                    <button
                      onClick={async () => {
                        let resultInsert = await updateAlloggio1(
                          token,
                          id_alloggio,
                          nome,
                          0,
                          foto
                        );
                        if (resultInsert.status == "ok") {
                          let get_tappe_conferma = await getTappeConferma(
                            token
                          );
                          await setAlloggi(get_tappe_conferma);
                          await setAlloggiBackup(get_tappe_conferma);
                          await handleCloseUpdate();
                        }
                      }}
                      aria-controls="example-collapse-text"
                      aria-expanded={open}
                      className="btn-prenotazione btn-prenotazione2"
                      style={{
                        boxShadow: "0px 3px 6px #00000029",
                        backgroundColor: "#FF9D00",
                        color: "#ffffff",
                        fontWeight: "600",
                        fontSize: "1em",
                        width: "100%",
                        border: "none",
                        borderRadius: "15px",
                        height: "48px",
                        position: "relative",
                        bottom: "30px",
                      }}
                    >
                      {" "}
                      Conferma Struttura
                    </button>
                  )}
                  <div className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Attivo
                    </label>
                    <select
                      defaultValue={attivo}
                      onChange={async (e) => {
                        await setAttivo(e.target.value);
                      }}
                      type="select"
                      id="orangeForm-name"
                      className="form-control validate"
                    >
                      <option value={0}>Attivo</option>
                      <option value={1}>Non Attivo</option>
                    </select>
                  </div>
                  <div className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Nome Struttura
                    </label>
                    <input
                      defaultValue={nome}
                      onChange={async (e) => {
                        await setNome(e.target.value);
                      }}
                      type="text"
                      id="orangeForm-name"
                      className="form-control validate"
                    />
                  </div>
                  <div className="mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Descrizione alloggio
                    </label>
                    <textarea
                      defaultValue={descrizione}
                      onChange={async (e) => {
                        await setDescrizione(e.target.value);
                      }}
                      type="text"
                      id="orangeForm-name"
                      className="form-control validate"
                    />
                  </div>

                  <div className="mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name-en"
                    >
                      Nome Struttura (Inglese)
                    </label>
                    <input
                      defaultValue={nome_en}
                      onChange={async (e) => {
                        await setNomeEn(e.target.value);
                      }}
                      type="text"
                      id="orangeForm-name-en"
                      className="form-control validate"
                    />
                  </div>

                  <div className="mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-desc-en"
                    >
                      Descrizione alloggio (Inglese)
                    </label>
                    <textarea
                      defaultValue={descrizione_en}
                      onChange={async (e) => {
                        await setDescrizioneEn(e.target.value);
                      }}
                      type="text"
                      id="orangeForm-desc-en"
                      className="form-control validate"
                    />
                  </div>

                  <div className=" mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Link
                    </label>
                    <input
                      defaultValue={link}
                      onChange={async (e) => {
                        await setLink(e.target.value);
                      }}
                      type="text"
                      id="orangeForm-name"
                      className="form-control validate"
                    />
                  </div>

                  <div className=" mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-luogo"
                    >
                      Indirizzo
                    </label>
                    <APIProvider
                      apiKey={"AIzaSyBAjNY-c5ShVgZKnPitfDh_S2kodqxTphc"}
                      solutionChannel="GMP_devsite_samples_v3_rgmautocomplete"
                    >
                      <div className="autocomplete-control">
                        <PlaceAutocomplete onPlaceSelect={setLuogo} defaultValue={luogo} />
                      </div>
                    </APIProvider>
                  </div>

                  <div className=" mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Telefono
                    </label>
                    <input
                      defaultValue={numero_telefono}
                      onChange={async (e) => {
                        await setNumeroTelefono(e.target.value);
                      }}
                      type="tel"
                      pattern="[0-9]*"
                      id="orangeForm-name"
                      className="form-control validate"
                    />
                  </div>

                  <div className=" mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Email
                    </label>
                    <input
                      defaultValue={email}
                      onChange={async (e) => {
                        await setEmail(e.target.value);
                      }}
                      type="email"
                      id="orangeForm-name"
                      className="form-control validate"
                    />
                  </div>

                  <div className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Tappa
                    </label>
                    <select
                      defaultValue={id_tappa}
                      onChange={async (e) => {
                        await setId_tappa(e.target.value);
                      }}
                      type="select"
                      id="orangeForm-name"
                      className="form-control validate"
                    >
                      <option value="gergerge">Seleziona una tappa</option>
                      {tappe.map((tappa) => (
                        <option key={tappa.id} value={tappa.id}>
                          {tappa.nome}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className=" mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Struttura in ZTL (Zona a Traffico Limitato)
                    </label>
                    <select
                      value={ztl}
                      onChange={async (e) => {
                        await setZtl(e.target.value);
                      }}
                      className="form-control validate"
                    >
                      <option value="NO">NO</option>
                      <option value="SÌ">SÌ</option>
                    </select>
                  </div>

                  {/*
                                   <div className=" mb-2">
                                        <i className="fas fa-user prefix grey-text"></i>
                                        <label data-error="wrong" data-success="right" for="orangeForm-name">Tappa associata</label>
                                        <select defaultValue="Seleziona una tappa associata" onChange={async (e) => {
                                            await setTappa(e.target.value);
                                        }} type="select" id="orangeForm-name" className="form-control validate">

                                            <option value="gergerge">Seleziona una tappa</option>
                                            {tappe.map((tappa) =>
                                                <option key={tappa.id} value={tappa.id} >{tappa.nome}</option>
                                            )}
                                        </select>
                                    </div>
                                            */}
                </div>
                <div className="">
                  {loader && (
                    <div style={{ textAlign: "center", paddingTop: "20px" }}>
                      <img src="/loader.gif" style={{ borderRadius: "100%" }} />
                    </div>
                  )}
                  {!loader && (
                    <button
                      onClick={async () => {
                        await setLoader(true);
                        let check_campi = await checkCampi(
                          nome,
                          descrizione,
                          file,
                          link,
                          luogo,
                          id_tappa,
                          upload_preview,
                          foto
                        );
                        if (check_campi == true) {
                          await setModalError("");
                          try {
                            let resultInsert = await updateAlloggio(
                              token,
                              id_alloggio,
                              nome,
                              file,
                              descrizione,
                              prezzo_min,
                              prezzo_max,
                              link,
                              luogo,
                              numero_telefono,
                              email,
                              costo_pre_prenotazione,
                              id_tappa,
                              foto,
                              attivo,
                              nome_en,
                              descrizione_en,
                              luogo_en,
                              ztl
                            );
                            if (resultInsert && resultInsert.status === "ok") {
                              handleCloseUpdate();
                              let result_post_update = await getAlloggi(token);
                              setAlloggi(result_post_update);
                              setAlloggiBackup(result_post_update);
                              for (let i = 0; i < result_post_update.length; i++) {
                                if (result_post_update[i].stato == 0) {
                                  await setConferma(true);
                                  break;
                                } else {
                                  await setConferma(false);
                                }
                              }
                            } else {
                              const backendMsg = resultInsert && resultInsert.message;
                              await setModalError(
                                typeof backendMsg === "string" && backendMsg.length > 0
                                  ? backendMsg
                                  : "Errore durante l'aggiornamento. Riprovare."
                              );
                            }
                          } catch (err) {
                            const respMsg = err && err.response && err.response.data && err.response.data.message;
                            await setModalError(
                              typeof respMsg === "string" && respMsg.length > 0
                                ? respMsg
                                : (err && err.message) || "Errore di rete. Verificare i dati e riprovare."
                            );
                          } finally {
                            await setLoader(false);
                          }
                        } else {
                          await setLoader(false);
                          await setModalError(check_campi);
                        }
                      }}
                      className="btn btn-deep-orange close btn-update"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      Salva
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        className="offcanvas-custom"
        placement="end"
        show={show}
        onHide={handleClose}
      >
        <Offcanvas.Header>
          <img
            onClick={handleClose}
            className="btn-close-img"
            src="/closeBtn.svg"
          />
          <p
            style={{
              color: "#B1B1B1",
              fontSize: "2em",
              marginBottom: "0",
              position: "absolute",
              left: "60px",
            }}
          >
            Strutture - Aggiungi
          </p>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div style={{ paddingLeft: "35px", paddingRight: "35px" }}>
            <div>
              <div>
                <div>
                  <h1
                    style={{
                      fontSize: "1.3em",
                      fontWeight: "700",
                      marginBottom: "40px",
                      marginTop: "30px",
                    }}
                  >
                    Aggiungi Struttura
                  </h1>
                  <div style={{ marginTop: "40px" }} className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      style={{ marginBottom: "20px" }}
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Aggiungi Immagine
                    </label>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        style={{
                          height: "100px",
                          width: "100px",
                          display: "inline-block",
                          backgroundImage: `url(${upload_preview == "/immagine_profilo_default.svg"
                            ? upload_preview
                            : upload_preview
                            })`,
                          backgroundSize: "cover",
                          borderRadius: "100%",
                          backgroundPosition: "center",
                        }}
                      ></div>
                      <label
                        htmlFor={`upload-photo-Immagine`}
                        className="file"
                        style={{
                          width: "70%",
                          position: "relative",
                          left: "20px",
                          bottom: "8px",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <span>
                          <h6
                            style={{
                              display: "inline-block",
                              marginBottom: "0px",
                            }}
                          >
                            Aggiungi Immagine
                          </h6>
                        </span>
                        <input
                          type="file"
                          style={{
                            opacity: "0",
                            position: "absolute",
                            zIndex: "-1",
                          }}
                          id={`upload-photo-Immagine`}
                          onChange={async (e) => {
                            if (e.target.files[0]) {
                              await setUploadPreview(
                                URL.createObjectURL(e.target.files[0])
                              );
                            }
                            await setFile(e.target.files[0]);
                          }}
                        />
                      </label>
                    </div>
                  </div>

                  <div className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Attivo
                    </label>
                    <select
                      defaultValue={attivo}
                      onChange={async (e) => {
                        await setAttivo(e.target.value);
                      }}
                      type="select"
                      id="orangeForm-name"
                      className="form-control validate"
                    >
                      <option value={0}>Attivo</option>
                      <option value={1}>Non Attivo</option>
                    </select>
                  </div>

                  <div className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Nome Struttura
                    </label>
                    <input
                      onChange={async (e) => {
                        await setNome(e.target.value);
                      }}
                      type="text"
                      id="orangeForm-name"
                      className="form-control validate"
                    />
                  </div>
                  <div className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Descrizione Struttura
                    </label>
                    <textarea
                      onChange={async (e) => {
                        await setDescrizione(e.target.value);
                      }}
                      type="text"
                      id="orangeForm-name"
                      className="form-control validate"
                    />
                  </div>

                  <div className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name-en"
                    >
                      Nome Struttura (Inglese)
                    </label>
                    <input
                      onChange={async (e) => {
                        await setNomeEn(e.target.value);
                      }}
                      type="text"
                      id="orangeForm-name-en"
                      className="form-control validate"
                    />
                  </div>

                  <div className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-desc-en"
                    >
                      Descrizione Struttura (Inglese)
                    </label>
                    <textarea
                      onChange={async (e) => {
                        await setDescrizioneEn(e.target.value);
                      }}
                      type="text"
                      id="orangeForm-desc-en"
                      className="form-control validate"
                    />
                  </div>

                  <div className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Link
                    </label>
                    <input
                      onChange={async (e) => {
                        await setLink(e.target.value);
                      }}
                      type="text"
                      id="orangeForm-name"
                      className="form-control validate"
                    />
                  </div>

                  <div className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-luogo"
                    >
                      Indirizzo
                    </label>
                    <APIProvider
                      apiKey={"AIzaSyBAjNY-c5ShVgZKnPitfDh_S2kodqxTphc"}
                      solutionChannel="GMP_devsite_samples_v3_rgmautocomplete"
                    >
                      <div className="autocomplete-control">
                        <PlaceAutocomplete onPlaceSelect={setLuogo} />
                      </div>
                    </APIProvider>
                  </div>

                  <div className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Telefono
                    </label>
                    <input
                      onChange={async (e) => {
                        await setNumeroTelefono(e.target.value);
                      }}
                      type="tel"
                      pattern="[0-9]*"
                      id="orangeForm-name"
                      className="form-control validate"
                    />
                  </div>

                  <div className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Email
                    </label>
                    <input
                      onChange={async (e) => {
                        await setEmail(e.target.value);
                      }}
                      type="email"
                      id="orangeForm-name"
                      className="form-control validate"
                    />
                  </div>

                  <div className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Tappa
                    </label>
                    <select
                      defaultValue="Seleziona una tappa associata"
                      onChange={async (e) => {
                        await setTappa(e.target.value);
                      }}
                      type="select"
                      id="orangeForm-name"
                      className="form-control validate"
                    >
                      <option value="gergerge">Seleziona una tappa</option>
                      {tappe.map((tappa) => (
                        <option key={tappa.id} value={tappa.id}>
                          {tappa.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="modal-footer d-flex justify-content-center">
                  {loader && (
                    <div style={{ textAlign: "center", paddingTop: "20px" }}>
                      <img src="/loader.gif" style={{ borderRadius: "100%" }} />
                    </div>
                  )}

                  {!loader && (
                    <button
                      onClick={async () => {
                        await setLoader(true);
                        let check_campi = await checkCampi(
                          nome,
                          descrizione,
                          file,
                          link,
                          luogo,
                          tappa,
                          upload_preview,
                          foto
                        );
                        if (check_campi == true) {
                          await setModalError("");
                          try {
                            let resultInsert = await insertAlloggio(
                              token,
                              id_alloggio,
                              nome,
                              descrizione,
                              file,
                              prezzo_min,
                              prezzo_max,
                              link,
                              luogo,
                              numero_telefono,
                              email,
                              costo_pre_prenotazione,
                              tappa,
                              attivo,
                              nome_en,
                              descrizione_en,
                              luogo_en
                            );
                            if (resultInsert && resultInsert.status === "ok") {
                              handleClose();
                              let result_post_delete = await getAlloggi(token);
                              setAlloggi(result_post_delete);
                              setAlloggiBackup(result_post_delete);
                            } else {
                              const backendMsg = resultInsert && resultInsert.message;
                              await setModalError(
                                typeof backendMsg === "string" && backendMsg.length > 0
                                  ? backendMsg
                                  : "Errore durante il salvataggio. Riprovare."
                              );
                            }
                          } catch (err) {
                            const respMsg = err && err.response && err.response.data && err.response.data.message;
                            await setModalError(
                              typeof respMsg === "string" && respMsg.length > 0
                                ? respMsg
                                : (err && err.message) || "Errore di rete. Verificare i dati e riprovare."
                            );
                          } finally {
                            await setLoader(false);
                          }
                        } else {
                          await setLoader(false);
                          await setModalError(check_campi);
                        }
                      }}
                      className="btn btn-deep-orange close btn-update"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      Aggiungi
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        className="offcanvas-custom"
        placement="end"
        show={showInfo}
        onHide={handleCloseInfo}
      >
        <Offcanvas.Header>
          <img
            onClick={handleCloseInfo}
            className="btn-close-img"
            src="/closeBtn.svg"
          />
          <p
            style={{
              color: "#B1B1B1",
              fontSize: "2em",
              marginBottom: "0",
              position: "absolute",
              left: "60px",
            }}
          >
            Strutture - Info
          </p>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div>
            <div>
              <div>
                <div style={{ paddingLeft: "30px", paddingRight: "30px" }}>
                  <div
                    className="div-image"
                    style={{
                      backgroundImage: `url("${foto}")`,
                      display: "inline-block",
                    }}
                  ></div>
                  <div
                    style={{
                      display: "inline-block",
                      position: "relative",
                      bottom: "50px",
                      left: "30px",
                    }}
                  >
                    <img
                      onClick={async () => {
                        setShowInfo(false);
                        setShowUpdate(true);
                        let get_tappe = await getTappe(token);
                        await setTappe(get_tappe);
                      }}
                      style={{ marginBottom: "13px", cursor: "pointer" }}
                      src="/updateTable.svg"
                    />
                    <br></br>
                    <img
                      onClick={() => {
                        setShowDelete(true);
                        setShowInfo(false);
                      }}
                      style={{ cursor: "pointer" }}
                      src="/deleteTable.svg"
                    />
                  </div>
                  <div className=" mb-2">
                    <p className="nome">{nome}</p>
                    <p className="nome">{nome_en ? `(EN) ${nome_en}` : ''}</p>
                  </div>

                  <div className="md-form  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <b>Attivo</b>
                    <p style={{ color: "#A9DE5B" }}>
                      {attivo == 0 && "Attivo"}
                    </p>
                    <p
                      style={{
                        color: "red",
                        position: "relative",
                        bottom: "10px",
                      }}
                    >
                      {attivo == 1 && "Non Attivo"}
                    </p>
                  </div>
                  <div className="md-form  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <b>Id Struttura</b>
                    <p>{id_alloggio}</p>
                  </div>
                  <div className="md-form  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <b>id Tappa</b>
                    <p>{id_tappa}</p>
                  </div>

                  <div className="md-form  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <b>Indirizzo</b>
                    <p>{luogo}</p>
                  </div>

                  <div className="md-form  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <b>Indirizzo (Inglese)</b>
                    <p>{luogo_en}</p>
                  </div>

                  <div className="md-form  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <b>Email</b>
                    <p>{email}</p>
                  </div>

                  <div className="md-form  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <b>Link</b>
                    <p style={{ wordBreak: "break-all" }}>{link}</p>
                  </div>

                  <div className="md-form  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <b>Indirizzo</b>
                    <p>{luogo}</p>
                  </div>

                  <div className="md-form  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <b>Telefono</b>
                    <p>{numero_telefono}</p>
                  </div>
                  <div className="md-form  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <b>Nome referente</b>
                    <p>{nome_referente}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <div
        style={{
          paddingTop: "20px",
          width: "100%",
          backgroundColor: "#F4F4F4",
        }}
      >
        <h1 className="title-sezione">
          <img
            src="struttureIcon.svg"
            style={{
              position: "relative",
              bottom: "3px",
              width: "23px",
              marginRight: "12px",
            }}
          />
          Strutture
        </h1>
        <div
          style={{
            marginTop: "30px",
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginBottom: "20px",
          }}
        >
          <div style={{ flex: 1 }}>
            <SearchForm nome="Cerca" search={search} />
          </div>
            {!open && (
              <button
                variant="primary"
                onClick={async () => {
                  let get_tappe_conferma = await getTappeConferma(token);
                  await setOpen(true);

                  //order get_tappe_conferma array from last to first
                  let get_tappe_conferma_ordered = get_tappe_conferma.sort(
                    function (a, b) {
                      return b.id - a.id;
                    }
                  );

                  await setAlloggi(get_tappe_conferma_ordered);
                  await setAlloggiBackup(get_tappe_conferma_ordered);
                }}
                className="btn btn-default btn-rounded btn-prenotazione btn-prenotazione2"
                data-toggle="modal"
                data-target="#modalRegisterForm"
                style={{
                  backgroundColor: "#FF9D00",
                  color: "#ffffff",
                  fontWeight: "700",
                  border: "none",
                  boxShadow: "0px 3px 6px #00000029",
                  borderRadius: "20px",
                  height: "50px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  fontSize: "0.9em",
                  whiteSpace: "nowrap",
                  position: "relative",
                }}
              >
                {conferma && (
                  <div
                    style={{
                      position: "absolute",
                      width: "10px",
                      height: "10px",
                      top: "8px",
                      right: "8px",
                      backgroundColor: "red",
                      borderRadius: "100%",
                    }}
                  ></div>
                )}
                Strutture da confermare
              </button>
            )}
            {open && (
              <button
                variant="primary"
                onClick={async () => {
                  let result = await getAlloggi(token);

                  await setOpen(false);
                  await setAlloggi(result);
                  await setAlloggiBackup(result);

                  for (let i = 0; i < result.length; i++) {
                    if (result[i].stato == 0) {
                      await setConferma(true);
                      break;
                    } else {
                      await setConferma(false);
                    }
                  }
                }}
                className="btn btn-default btn-rounded btn-prenotazione btn-prenotazione1"
                data-toggle="modal"
                data-target="#modalRegisterForm"
                style={{
                  backgroundColor: "#FF9D00",
                  color: "#ffffff",
                  fontWeight: "700",
                  border: "none",
                  boxShadow: "0px 3px 6px #00000029",
                  borderRadius: "20px",
                  height: "50px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  fontSize: "0.9em",
                  whiteSpace: "nowrap",
                }}
              >
                Tutte le Strutture
              </button>
            )}

          <button
            variant="primary"
            onClick={async () => {
              handleShow();
              let get_tappe = await getTappe(token);
              await setTappe(get_tappe);
            }}
            className="btn btn-default btn-rounded aggiungi-struttura"
            data-toggle="modal"
            data-target="#modalRegisterForm"
            style={{
              border: "none",
              boxShadow: "0px 3px 6px #00000029",
              borderRadius: "20px",
              height: "50px",
              paddingLeft: "20px",
              paddingRight: "20px",
              fontSize: "0.9em",
              whiteSpace: "nowrap",
            }}
          >
            Aggiungi Struttura
          </button>
        </div>
      </div>
      <div
        className="alloggi"
        style={{ marginTop: "30px", width: "100%", overflowX: "auto" }}
      >
        <table className="table" style={{ marginTop: "15px" }}>
          <thead style={{
            backgroundColor: "#F7F7F7",
            position: "sticky",
            top: 0,
            zIndex: 10
          }}>
            <tr>
              <th style={{ fontWeight: "700", padding: "15px 12px", fontSize: "0.95em", color: "#2F2F2F" }} scope="col">
                Id
              </th>
              <th style={{ fontWeight: "700", padding: "15px 12px", fontSize: "0.95em", color: "#2F2F2F" }} scope="col">Attivo</th>
              <th style={{ fontWeight: "700", padding: "15px 12px", fontSize: "0.95em", color: "#2F2F2F", minWidth: "250px" }} scope="col">Struttura</th>
              <th style={{ fontWeight: "700", padding: "15px 12px", fontSize: "0.95em", color: "#2F2F2F" }} scope="col">Indirizzo</th>
              <th style={{ fontWeight: "700", padding: "15px 12px", fontSize: "0.95em", color: "#2F2F2F" }} scope="col">Tappa</th>
              {open && <th style={{ fontWeight: "700", padding: "15px 12px", fontSize: "0.95em", color: "#2F2F2F" }} scope="col">Conferma</th>}
              <th style={{ fontWeight: "700", padding: "15px 12px", fontSize: "0.95em", color: "#2F2F2F" }} scope="col">Azioni</th>
            </tr>
            <tr style={{ backgroundColor: "#FFFFFF" }}>
              <th style={{ padding: "10px 12px" }}>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Filtra ID..."
                  value={filterId}
                  onChange={(e) => setFilterId(e.target.value)}
                  style={{ fontSize: "0.85em", borderRadius: "8px", border: "1px solid #ddd" }}
                />
              </th>
              <th style={{ padding: "10px 12px" }}>
                <select
                  className="form-control form-control-sm"
                  value={filtroAttivo}
                  onChange={(e) => setFiltroAttivo(e.target.value)}
                  style={{ fontSize: "0.85em", borderRadius: "8px", border: "1px solid #ddd", cursor: "pointer" }}
                >
                  <option value="">Tutti</option>
                  <option value="0">Attivo</option>
                  <option value="1">Non Attivo</option>
                  <option value="2">In attesa</option>
                </select>
              </th>
              <th style={{ padding: "10px 12px" }}>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Filtra struttura..."
                  value={filtroStruttura}
                  onChange={(e) => setFiltroStruttura(e.target.value)}
                  style={{ fontSize: "0.85em", borderRadius: "8px", border: "1px solid #ddd" }}
                />
              </th>
              <th style={{ padding: "10px 12px" }}>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Filtra indirizzo..."
                  value={filtroLocalita}
                  onChange={(e) => setFiltroLocalita(e.target.value)}
                  style={{ fontSize: "0.85em", borderRadius: "8px", border: "1px solid #ddd" }}
                />
              </th>
              <th style={{ padding: "10px 12px" }}>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Filtra tappa..."
                  value={filtroTappa}
                  onChange={(e) => setFiltroTappa(e.target.value)}
                  style={{ fontSize: "0.85em", borderRadius: "8px", border: "1px solid #ddd" }}
                />
              </th>
              {open && <th style={{ padding: "10px 12px" }}></th>}
              <th style={{ padding: "10px 12px" }}></th>
            </tr>
          </thead>
          {alloggi.length > 0 && (
            <tbody>
              {alloggi?.map((alloggio) => (
                <tr className="tr-white" key={alloggio.id}>
                  <th scope="row">{alloggio.id}</th>
                  {alloggio.attivo == 2 && (
                    <td
                      style={{
                        color: "orange",
                        fontSize: "0.8em",
                        fontWeight: "700",
                        marginBottom: "0",
                      }}
                    >
                      In attesa
                    </td>
                  )}

                  {alloggio.attivo == 1 && (
                    <td
                      style={{
                        color: "red",
                        fontSize: "0.8em",
                        fontWeight: "700",
                        marginBottom: "0",
                      }}
                    >
                      Non Attivo
                    </td>
                  )}
                  {alloggio.attivo == 0 && (
                    <td
                      style={{
                        color: "#A9DE5B",
                        fontSize: "0.8em",
                        fontWeight: "700",
                        marginBottom: "0",
                      }}
                    >
                      Attivo
                    </td>
                  )}
                  <td style={{ fontWeight: "600", minWidth: "250px", maxWidth: "350px", whiteSpace: "normal", wordBreak: "break-word" }}>
                    {alloggio?.nome}
                  </td>
                  <td>{alloggio.luogo}</td>
                  <td>{alloggio.tappa_nome || "N/A"}</td>
                  {open && (
                    <td style={{ width: "150px" }}>
                      {alloggio.stato == 0 && (
                        <button
                          onClick={async () => {
                            await setNome(alloggio.nome);
                            await setDescrizione(alloggio.descrizione);
                            await setFoto(alloggio.foto_alloggio);
                            await setLuogo(alloggio.luogo);
                            await setNumeroTelefono(alloggio.numero_telefono);
                            await setEmail(alloggio.email);
                            await setPrePrenotazione(
                              alloggio.costo_pre_prenotazione
                            );
                            await setPrezzoMin(alloggio.prezzo_min);
                            await setPrezzoMax(alloggio.prezzo_max);
                            await setLink(alloggio.link);
                            await setAttivo(0);
                            await setIdAlloggio(alloggio.id);
                            await setId_tappa(alloggio.id_tappa);
                            await setZtl(alloggio.ztl || "NO");
                            await setZtl(alloggio.ztl || "NO");
                            await setButtonConferma(true);
                            let get_tappe = await getTappe(token);
                            await setTappe(get_tappe);
                            handleShowUpdate();
                          }}
                          aria-controls="example-collapse-text"
                          aria-expanded={open}
                          className="btn-prenotazione btn-prenotazione2"
                          style={{
                            boxShadow: "0px 3px 6px #00000029",
                            backgroundColor: "#FF9D00",
                            color: "#ffffff",
                            fontWeight: "600",
                            fontSize: "0.8em",
                            width: "150px",
                            border: "none",
                            borderRadius: "15px",
                            height: "48px",
                          }}
                        >
                          Conferma
                        </button>
                      )}
                    </td>
                  )}
                  <td style={{ width: "150px" }}>
                    <button
                      onClick={async () => {
                        await setIdAlloggio(alloggio.id);
                        await setNome(alloggio.nome);
                        await setDescrizione(alloggio.descrizione);
                        await setFoto(alloggio.foto_alloggio);
                        await setLuogo(alloggio.luogo);
                        await setNumeroTelefono(alloggio.numero_telefono);
                        await setEmail(alloggio.email);
                        await setPrePrenotazione(
                          alloggio.costo_pre_prenotazione
                        );
                        await setPrezzoMin(alloggio.prezzo_min);
                        await setPrezzoMax(alloggio.prezzo_max);
                        await setLink(alloggio.link);
                        await setAttivo(alloggio.attivo);
                        await setId_tappa(alloggio.id_tappa);
                        await setZtl(alloggio.ztl || "NO");
                        await setNomeReferente(alloggio.nome_utente);

                        handleShowInfo();
                      }}
                      style={{
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        border: "none",
                      }}
                    >
                      <img
                        style={{
                          width: "25px",
                          position: "relative",
                          bottom: "3px",
                        }}
                        src="./infoTable.svg"
                      />
                    </button>
                    <button
                      onClick={async () => {
                        await setNome(alloggio.nome);
                        await setDescrizione(alloggio.descrizione);
                        await setFoto(alloggio.foto_alloggio);
                        await setLuogo(alloggio.luogo);
                        await setNumeroTelefono(alloggio.numero_telefono);
                        await setEmail(alloggio.email);
                        await setPrePrenotazione(
                          alloggio.costo_pre_prenotazione
                        );
                        await setPrezzoMin(alloggio.prezzo_min);
                        await setPrezzoMax(alloggio.prezzo_max);
                        await setLink(alloggio.link);
                        await setIdAlloggio(alloggio.id);

                        await setNomeReferente(alloggio.nome_utente);
                        await setAttivo(alloggio.attivo);
                        await setId_tappa(alloggio.id_tappa);
                        await setZtl(alloggio.ztl || "NO");
                        let get_tappe = await getTappe(token);
                        await setTappe(get_tappe);
                        handleShowUpdate();
                      }}
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        boxShadow: "none",
                      }}
                    >
                      <img
                        style={{
                          width: "25px",
                          position: "relative",
                          bottom: "3px",
                        }}
                        src="./updateTable.svg"
                      />
                    </button>
                    <button
                      onClick={async () => {
                        await setNome(alloggio.nome);
                        await setDescrizione(alloggio.descrizione);
                        await setFoto(alloggio.foto_alloggio);
                        await setLuogo(alloggio.luogo);
                        await setNumeroTelefono(alloggio.numero_telefono);
                        await setEmail(alloggio.email);
                        await setPrePrenotazione(
                          alloggio.costo_pre_prenotazione
                        );
                        await setPrezzoMin(alloggio.prezzo_min);
                        await setPrezzoMax(alloggio.prezzo_max);
                        await setLink(alloggio.link);
                        await setIdAlloggio(alloggio.id);

                        await setNomeReferente(alloggio.nome_utente);
                        await setAttivo(alloggio.attivo);
                        await setId_tappa(alloggio.id_tappa);
                        await setZtl(alloggio.ztl || "NO");
                        let get_tappe = await getTappe(token);
                        await setTappe(get_tappe);
                        setShowDelete(true);
                      }}
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        boxShadow: "none",
                      }}
                    >
                      <img
                        style={{
                          width: "25px",
                          position: "relative",
                          bottom: "3px",
                        }}
                        src="./deleteTable.svg"
                      />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
};

export default Alloggi;
